import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useContext, useState } from "react";

const ExitPollTally = ({
  electionPassedCategory = "",
  masterKey = "",
  stateName = "",
  stateHindi = "",
}) => {
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig[masterKey];
  const [isRegionalTab, setIsRegionalTab] = useState(false);
  const showExitPollTally = electionKeys?.showExitPollTally;
  const height = electionKeys?.exitPollHeight;
 const state_name= stateName?.split(" ")?.join("-")?.toLowerCase()
  return (
    <>
      { showExitPollTally&& (
        <div className="mx-4 md:mx-4 my-4">
          <div className=" items-center h-full">
            <h2 className="font-bold font-devnagri text-2xl">एग्जिट पोल</h2>
          </div>
          {/* <div className="flex gap-4 my-2 border-b-2 border-customPoll">
    <div className="flex">
      <button
        className={`${
          !isRegionalTab
            ? "bg-primary text-white"
            : "bg-blue-100 text-gray-500"
        } font-semibold px-4 py-2 rounded-tr-lg rounded-tl-lg`}
        onClick={() => setIsRegionalTab(false)}
      >
         {stateHindi} विधानसभा एग्जिट पोल
      </button>
    </div>
  
  </div> */}
          <div>
            {
              <iframe
                title="vidhan sabha exit poll"
                src={`${electionKeys?.showTallyURL}&state_name=${state_name}`}
                className={`min-h-[${height}px] w-full scrollbar-none`}
                height={height}
              />
            }
          </div>
        </div>
      ) }
    </>
  );
};

export default ExitPollTally;
